<template>
    <v-card :loading="loading" mx-4>
        <v-skeleton-loader
            v-if="loading"
            type="card"
        ></v-skeleton-loader>
        <v-tabs
            v-else
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
            <v-tab key="entry">
                Achizitie
            </v-tab>
            <v-tab v-if="id" key="exit">
                Scoatere din uz
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-select
                        :items="workstationItems"
                        v-model.lazy="form.workstation_id"
                        label="Punct de lucru"
                        data-vv-as="Punct de lucru"
                        v-validate="'required'"
                        :error-messages="errorMessages('workstation_id')"
                        :class="{ 'error--text': hasErrors('workstation_id') }"
                        class="primary--text"
                        name="workstation_id"
                        data-vv-name="workstation_id"
                    ></v-select>
                    <v-select
                        :items="brandsItems"
                        v-model.lazy="form.vehicle_brand_id"
                        label="Marca"
                        data-vv-as="Marca"
                        v-validate="'required'"
                        :error-messages="errorMessages('vehicle_brand_id')"
                        :class="{ 'error--text': hasErrors('vehicle_brand_id') }"
                        class="primary--text"
                        name="vehicle_brand_id"
                        data-vv-name="vehicle_brand_id"
                    ></v-select>
                    <v-select
                        :items="modelItems"
                        v-model.lazy="form.vehicle_model_id"
                        label="Model"
                        data-vv-as="Model"
                        v-validate="'required'"
                        :error-messages="errorMessages('vehicle_model_id')"
                        :class="{ 'error--text': hasErrors('vehicle_model_id') }"
                        class="primary--text"
                        name="vehicle_model_id"
                        data-vv-name="vehicle_model_id"
                    ></v-select>
                    <v-text-field
                        type="number"
                        v-model="form.data.year"
                        v-validate="'required'"
                        :error-messages="errorMessages('year')"
                        :class="{ 'error--text': hasErrors('year') }"
                        class="primary--text"
                        name="year"
                        label="An fabricatie"
                        data-vv-as="An fabricatie"
                        data-vv-name="year"
                        counter="255"
                    />
                    <v-select
                        :items="fuelItems"
                        v-model.lazy="form.data.fuel"
                        label="Combustibil"
                        data-vv-as="Combustibil"
                        v-validate="'required'"
                        :error-messages="errorMessages('fuel')"
                        :class="{ 'error--text': hasErrors('fuel') }"
                        class="primary--text"
                        name="fuel"
                        data-vv-name="fuel"
                    ></v-select>
                    <v-text-field
                        type="number"
                        v-model="form.data.avg_consumption"
                        v-validate="'required'"
                        :error-messages="errorMessages('avg_consumption')"
                        :class="{ 'error--text': hasErrors('avg_consumption') }"
                        class="primary--text"
                        name="avg_consumption"
                        label="Consum mediu"
                        data-vv-as="Consum mediu"
                        data-vv-name="avg_consumption"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.vehicle_plate"
                        v-validate="'required'"
                        :error-messages="errorMessages('vehicle_plate')"
                        :class="{ 'error--text': hasErrors('vehicle_plate') }"
                        class="primary--text"
                        name="vehicle_plate"
                        label="Numar inmatriculare"
                        data-vv-as="Numar inmatriculare"
                        data-vv-name="vehicle_plate"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.vehicle_vin"
                        v-validate="'required'"
                        :error-messages="errorMessages('vehicle_vin')"
                        :class="{ 'error--text': hasErrors('vehicle_vin') }"
                        class="primary--text"
                        name="vehicle_vin"
                        label="Numar VIN"
                        data-vv-as="Numar VIN"
                        data-vv-name="vehicle_vin"
                        counter="255"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salvare
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="addresses">
                <v-card class="px-4 py-4" flat>
                    <v-menu
                        ref="entryDateMenu"
                        v-model="entryDateMenu"
                        :close-on-content-click="false"
                        :return-value.sync="form.data.entry_date"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.data.entry_date"
                                label="Data achizitiei"
                                data-vv-as="Data achizitiei"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-validate="'required'"
                                :error-messages="errorMessages('data.entry_date')"
                                :class="{ 'error--text': hasErrors('data.entry_date') }"
                                class="primary--text"
                                data-vv-name="data.entry_date"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="form.data.entry_date"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="entryDateMenu = false"
                            >
                                Iesire
                            </v-btn>
                            <v-btn
                                text
                                color="warning"
                                @click="$refs.entryDateMenu.save(null)"
                            >
                                Anulare
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.entryDateMenu.save(form.data.entry_date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>

                    <v-text-field
                        type="number"
                        v-model="form.data.entry_km"
                        v-validate="'required'"
                        :error-messages="errorMessages('data.entry_km')"
                        :class="{ 'error--text': hasErrors('data.entry_km') }"
                        class="primary--text"
                        name="data.entry_km"
                        label="Rulaj achizitie"
                        data-vv-as="Rulaj achizitie"
                        data-vv-name="data.entry_km"
                        counter="255"
                    />

                    <v-text-field
                        type="number"
                        v-model="form.data.entry_price"
                        v-validate="''"
                        :error-messages="errorMessages('data.entry_price')"
                        :class="{ 'error--text': hasErrors('data.entry_price') }"
                        class="primary--text"
                        name="data.entry_price"
                        label="Pret achizitie"
                        data-vv-as="Pret achizitie"
                        data-vv-name="data.entry_price"
                        counter="255"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salvare
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="history">
                <v-card class="px-4 py-4" flat>
                    <v-menu
                        ref="endDateMenu"
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :return-value.sync="form.data.end_date"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.data.end_date"
                                prepend-icon="mdi-calendar"
                                label="Data scoaterii din uz"
                                data-vv-as="Data scoaterii din uz"
                                readonly
                                v-validate="''"
                                :error-messages="errorMessages('data.end_date')"
                                :class="{ 'error--text': hasErrors('data.end_date') }"
                                class="primary--text"
                                data-vv-name="data.end_date"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="form.data.end_date"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="endDateMenu = false"
                            >
                                Iesire
                            </v-btn>
                            <v-btn
                                text
                                color="warning"
                                @click="$refs.endDateMenu.save(null)"
                            >
                                Anulare
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.endDateMenu.save(form.data.end_date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>

                    <v-text-field
                        type="number"
                        v-model="form.data.end_km"
                        v-validate="''"
                        :error-messages="errorMessages('data.end_km')"
                        :class="{ 'error--text': hasErrors('data.end_km') }"
                        class="primary--text"
                        name="data.end_km"
                        label="Rulaj in momentul scoaterii din uz"
                        data-vv-as="Rulaj in momentul scoaterii din uz"
                        data-vv-name="data.end_km"
                        counter="255"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salvare
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    const { mapState } = createNamespacedHelpers("workstation");
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import swal from "sweetalert2";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            entryDateMenu: false,
            endDateMenu: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                workstation_id: null,
                vehicle_brand_id: null,
                vehicle_model_id: null,
                vehicle_plate: null,
                vehicle_vin: null,
                data: {
                    year: null,
                    fuel: null,
                    avg_consumption: null,
                    entry_km: null,
                    entry_date: null,
                    entry_price: null,
                    end_km: null,
                    end_date: null,
                }
            }),
        }),
        computed: {
            ...mapState({
                availableWorkstations: "availableWorkstations"
            }),
            workstationItems() {
                return this.availableWorkstations.map((workstation) => {
                    return {
                        value: workstation.id,
                        text: workstation.name
                    }
                })
            },
            brandsItems () {
                return this.Static.vehicleBrands.map((item) => {
                    return {
                        value: item.id,
                        text: item.name
                    }
                })
            },
            modelItems () {
                if(this.form.vehicle_brand_id === null) return []
                return this.Static.vehicleModels
                    .filter((item) => item.brand_id === this.form.vehicle_brand_id)
                    .map((item) => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
            },
            fuelItems () {
                return Object.keys(this.Static.fuelTypes)
                    .map((item) => {
                        return {
                            value: item,
                            text: this.Static.fuelTypes[item]
                        }
                    })
            },
        },
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Vehicle
                    .include(
                        'make',
                        'model'
                    )
                    .where('withTrashed', 1)
                    .find(this.id)
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Vehicle(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "vehicles-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            }
        }
    };
</script>
